import React, { StrictMode } from "react"
import { injectGlobal } from "emotion"
import { createRoot } from "react-dom/client"
import { Main } from "./app/main"
import { monkeyPatchLoggers } from "./common/utils/utils"

monkeyPatchLoggers()

// eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-unused-expressions
injectGlobal`
    body {
        margin: 0; padding: 0;
    }
    *, html {
        box-sizing: border-box;
    }
    *, *:before, *:after {
        box-sizing: inherit;
    }
`

// TODO: Re-enable once @axe-core update to support React 18 https://github.com/dequelabs/axe-core-npm/issues/500
/* if (process.env.NODE_ENV !== "production") {

    const axe = require("@axe-core/react") // eslint-disable-line @typescript-eslint/no-var-requires,global-require

    // last argument is time in ms for how long react-axe will wait after component renders before it will begin analysis again
    axe(React, ReactDOM, 1000)
} */

document.addEventListener("DOMContentLoaded", () => {
    const container = document.getElementById("main")
    if (container) {
        const root = createRoot(container)
        root.render(
            <StrictMode>
                <Main />
            </StrictMode>
        )
    }
})
